import 'component/css/service-edit.css';

import moment from 'moment';
import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindowMaximize,
  faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';

import Util from 'service/util';
import DataUtil from 'service/data-util';

import ModalScreen from 'component/ModalScreen';
import Protected from 'component/Protected';

import AddServiceModal       from 'component/service-edit/AddServiceModal';
import EditServiceModal      from 'component/service-edit/EditServiceModal';
import ChangeServiceModal    from 'component/service-edit/ChangeServiceModal';
import SuspendServiceModal   from 'component/service-edit/SuspendServiceModal';
import TerminateServiceModal from 'component/service-edit/TerminateServiceModal';
import RemoveServiceModal    from 'component/service-edit/RemoveServiceModal';
import DataGridServiceModal  from 'component/service-edit/DataGridServiceModal';

import ServiceList from 'component/ServiceList';
import SuspensionHistory from 'component/service/SuspensionHistory';
import ChangeLicense from 'component/service/ChangeLicense';
import ServiceSelectModeBar from 'component/service/ServiceSelectModeBar';

const ServiceEdit = (props) =>
{

  const [vehicle, setVehicle]            = useState(props.vehicle);
  const [modal, setModal]                = useState(null);
  const [maximize_srv_list, setMaximize] = useState(false);

  const toggleMaximize = e=>setMaximize(!maximize_srv_list);

  const showModal = (mode, min_dtm, service) =>
  {
    const dictModeComponent = {
      add:    AddServiceModal,
      edit:   EditServiceModal,
      change: ChangeServiceModal,
      susp:   SuspendServiceModal,
      term:   TerminateServiceModal,
      del:    RemoveServiceModal,
      grid:   DataGridServiceModal,
    };

    if (service) {
      if ('string' === typeof service.start_dtm) service.start_dtm = moment(service.start_dtm).toDate();
      if ('string' === typeof service.end_dtm) service.end_dtm = service.end_dtm ? moment(service.end_dtm).toDate() : null;
    }

    let DynamicModal = dictModeComponent[mode];
    if (!DynamicModal) setModal(null);
    else {
      setModal(<DynamicModal {...props}
        {...{min_dtm, vehicle, service, closeModal, onCreatedService, onUpdatedService}}
      />);
    }
  }
  const closeModal = () => setModal(null);
  const showSuspensionHistory = () => {
    let modal = (
      <ModalScreen show={true} title={`服務停用記錄 - ${vehicle.cd_license}`} onClose={closeModal}>
        <SuspensionHistory license={vehicle.cd_license} />
      </ModalScreen>
    );
    setModal(modal);
  }

  const showChangeLicenseModal = () => {
    let modal = (
      <ModalScreen show={true} title={`轉車牌 - ${vehicle.cd_license}`}
          onClose={closeModal}>
        <ChangeLicense vehicle={vehicle} />
      </ModalScreen>
    )
    setModal(modal);
  }

  const onCreatedService = (service) =>
  {
    vehicle.services = Array.from(vehicle.services);
    vehicle.services.unshift(service);
    checkActiveService();
  }
  const onUpdatedService = (list) =>
  {
    vehicle.services = list;
    checkActiveService();
  }
  const checkActiveService = () =>
  {
    DataUtil.attachVehicleActiveService(vehicle);
    props.onUpdated(vehicle.services);
  }

  const start_a1 = () => {
    return Util.trimDate(vehicle.activeService.start_dtm).add(1, 'd');
  }

  //------------------
  // init
  useEffect(() => {
    setVehicle(props.vehicle);
  }, [props.vehicle]);


  let minMaxStyle = maximize_srv_list
    ?'box op-service-history maximized'
    :'box op-service-history';

  let gm_end_dtm = vehicle.services
    ?.map(x => x.end_dtm).reduce(
      (r,x) => !r? x : (moment(x).isAfter(r) ? x : r)
    , null);

  return (
    <div className={minMaxStyle}>
      <h4 className="box-head action-panel">
        <span>服務記錄 - { vehicle.cd_license }</span>
        <span id="btn-mx-hist">
          { maximize_srv_list
            ?<FontAwesomeIcon icon={faWindowMinimize} onClick={ toggleMaximize } />
            :<FontAwesomeIcon icon={faWindowMaximize} onClick={ toggleMaximize } />
          }
        </span>
      </h4>
      <div className="box-body">
        <div className="service-edit-button-group">
          <button type="button" className="btn white" onClick={ showSuspensionHistory }>服務停用記錄</button>
          <Protected allow={['ADMIN','OPERATOR']}>
            <ServiceSelectModeBar {...{start_a1, vehicle, showModal}}/>
            <button type="button" className="btn blue" onClick={ showChangeLicenseModal }>轉車牌</button>
            <button className="btn red" onClick={e=>showModal('grid')}>進階</button>
          </Protected>
        </div>
        <ServiceList
          gm_end_dtm= { gm_end_dtm }
          services={ vehicle.services }
          showModal={ showModal } />
      </div>
      { modal }
    </div>
  );

}

export default ServiceEdit;
